
export interface IPlant {
    _id: string;
    ownerEmail: string;
    sourceCatalogPlantId: string | null;
    name: string;
    imageUrl: string | null;
    description: string | null;
    timeToGrow: {
        min: string | null;
        max: string | null;
    };
    season: 'Spring' | 'Summer' | 'Autumn' | 'Winter' | null;
    seasonToAvoid: 'Spring' | 'Summer' | 'Autumn' | 'Winter' | null;
    waterFrequency: string | null;
    careSchedule: PlantCareSchedule;
    sunlight: {
        _id: string;
        requirement: 'Full Sun' | 'Partial Shade' | 'Full Shade' | null;
        hoursOfSunlight: string | null;
        createdAt: Date;
        updatedAt: Date;
    };
    soilType: string | null;
    fertilizer: {
        _id: string;
        name: string | null;
        type: string | null;
        npkRatio: {
            nitrogen: number;
            phosphorus: number;
            potassium: number;
        };
        createdAt: Date;
        updatedAt: Date;
    };
    isIndoor: boolean;
    isOutdoor: boolean;
    createdAt: Date;
    updatedAt: Date;
    type: 'plant';
}

export interface PlantCareSchedule {
    wateringIntervalDays: number | null;
    lastWateredAt: Date | null;
    nextWateringAt: Date | null;
    reminderEnabled: boolean;
}

export const EmptyCareSchedule = {
    wateringIntervalDays: null,
    lastWateredAt: null,
    nextWateringAt: null,
    reminderEnabled: false,
} as PlantCareSchedule;

export interface FertilizerType {
    _id: string;
    name: string | null;
    type: string | null;
    npkRatio: {
        nitrogen: number;
        phosphorus: number;
        potassium: number;
    };
    createdAt: Date;
    updatedAt: Date;
}

export interface TimeToGrow {
    min: string | null;
    max: string | null;
}

export const EmptyTimeToGrow = {
    min: null as string | null,
    max: null as string | null,
} as TimeToGrow;

export interface SunlightRequirements {
    _id: string;
    requirement: 'Full Sun' | 'Partial Shade' | 'Full Shade' | null;
    hoursOfSunlight: string | null;
    createdAt: Date;
    updatedAt: Date;
}

export const EmptySunReqs = {
    _id: '',
    requirement: null,
    hoursOfSunlight: null as string | null,
    createdAt: new Date(),
    updatedAt: new Date(),
} as SunlightRequirements;

export const EmptyFertReqs = {
    _id: '',
    name: null,
    type: null,
    npkRatio: {
        nitrogen: 0,
        phosphorus: 0,
        potassium: 0,
    },
    createdAt: new Date(),
    updatedAt: new Date(),
} as FertilizerType;

export const EmptyPlant = {
    _id: '',
    ownerEmail: '',
    sourceCatalogPlantId: null,
    name: '',
    imageUrl: null,
    description: null,
    timeToGrow: {
        min: null,
        max: null,
    },
    season: null,
    seasonToAvoid: null,
    waterFrequency: null,
    careSchedule: EmptyCareSchedule,
    sunlight: EmptySunReqs,
    soilType: null,
    fertilizer: EmptyFertReqs,
    isIndoor: false,
    isOutdoor: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    type: 'plant' as 'plant',
}
